import { render } from "./slidesdb_chap00.vue?vue&type=template&id=77bda07c&scoped=true"
import script from "./slidesdb_chap00.vue?vue&type=script&lang=js"
export * from "./slidesdb_chap00.vue?vue&type=script&lang=js"

import "@/assets/css/globalcn.css?vue&type=style&index=0&id=77bda07c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bda07c"]])

export default __exports__